import { circleQuestion } from "@simplybusiness/icons";
import { Button, Flex, Icon, Modal } from "@simplybusiness/mobius";
import type { ReactNode } from "react";
import { useState } from "react";

export type CardModalProps = {
  toggleText: string;
  title?: ReactNode;
  body: ReactNode;
  onOpen?: () => void;
  toggleIcon?: boolean;
  isCoreCover?: boolean;
};

export const CardModal = ({
  toggleText,
  title,
  body,
  onOpen,
  toggleIcon = true,
}: CardModalProps) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (onOpen) {
      onOpen();
    }

    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <Flex gap="xxs">
      <Button
        variant="ghost"
        className="mobius-quote-card__modal-trigger"
        onClick={handleOpen}
      >
        <Flex>
          <span className="mobius-quote-card__explainer-title">
            {toggleText}
          </span>
          {toggleIcon && (
            <Icon
              icon={circleQuestion}
              size="sm"
              className="mobius-quote-card__explainer-icon"
            />
          )}
        </Flex>
      </Button>
      <Modal
        isOpen={open}
        onClose={handleClose}
        className="mobius-quote-card__modal-container"
        animation="fade"
      >
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>{body}</Modal.Content>
      </Modal>
    </Flex>
  );
};
